import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'trigger',
    label: 'Trigger',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
